<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import localSave from '@utils/local-save'
import { useSearchStore } from '@state/stores/search'

const searchStore = useSearchStore()
const route = useRoute()
const router = useRouter()

const searchInput = ref(null)
const searchKeyword = ref('')

const routeKeyword = computed(() => route && route.params && route.params.keyword)

onMounted(() => {
    if (routeKeyword.value) {
        searchKeyword.value = routeKeyword.value.replace(/_/g, ' ')
        searchStore.updateKeyword(searchKeyword.value)
    }
    searchInput.value.focus()
})

function onSearch(keyword) {
    searchStore.updateKeyword(keyword)
}

function onClose() {
    if (searchKeyword.value && searchKeyword.value.length) {
        searchKeyword.value = ''
        return
    }

    const previousPath = localSave.get('searchPreviousPath', 'sessionStorage')

    if (previousPath && !previousPath.includes('/search')) {
        router.push({ path: previousPath, query: { back: true } })
    }
}
</script>

<template>
    <div class="search-bar">
        <BaseSearchInput
            ref="searchInput"
            v-model="searchKeyword"
            placeholder="What do you want to listen to?"
            variant="page"
            autofocus
            @search="onSearch"
        >
            <template #append>
                <a @click="onClose">
                    <BaseIcon
                        class="search-bar-close-icon"
                        name="close"
                    />
                </a>
            </template>
        </BaseSearchInput>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.search-bar {
    display: flex;
    align-items: center;
    width: 100%;
    height: $size-search-bar-height;
    padding: 0 $s-xl;
    background-color: $c-searchbar-bg;
}

.search-bar-close-icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: $c-white;
    cursor: pointer;
}
</style>
